/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartnerMaintenanceScopeHierarchyAssetDto } from './PartnerMaintenanceScopeHierarchyAssetDto';
import {
    PartnerMaintenanceScopeHierarchyAssetDtoFromJSON,
    PartnerMaintenanceScopeHierarchyAssetDtoFromJSONTyped,
    PartnerMaintenanceScopeHierarchyAssetDtoToJSON,
    PartnerMaintenanceScopeHierarchyAssetDtoToJSONTyped,
} from './PartnerMaintenanceScopeHierarchyAssetDto';
import type { PartnerMaintenanceScopeOptionDto } from './PartnerMaintenanceScopeOptionDto';
import {
    PartnerMaintenanceScopeOptionDtoFromJSON,
    PartnerMaintenanceScopeOptionDtoFromJSONTyped,
    PartnerMaintenanceScopeOptionDtoToJSON,
    PartnerMaintenanceScopeOptionDtoToJSONTyped,
} from './PartnerMaintenanceScopeOptionDto';

/**
 * 
 * @export
 * @interface PartnerMaintenanceScopeOptionsResponseDto
 */
export interface PartnerMaintenanceScopeOptionsResponseDto {
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    manufacturers: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    models: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    departments: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    communes: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    postcodes: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeOptionDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    assets: Array<PartnerMaintenanceScopeOptionDto>;
    /**
     * 
     * @type {Array<PartnerMaintenanceScopeHierarchyAssetDto>}
     * @memberof PartnerMaintenanceScopeOptionsResponseDto
     */
    assetHierarchy: Array<PartnerMaintenanceScopeHierarchyAssetDto>;
}

/**
 * Check if a given object implements the PartnerMaintenanceScopeOptionsResponseDto interface.
 */
export function instanceOfPartnerMaintenanceScopeOptionsResponseDto(value: object): value is PartnerMaintenanceScopeOptionsResponseDto {
    if (!('manufacturers' in value) || value['manufacturers'] === undefined) return false;
    if (!('models' in value) || value['models'] === undefined) return false;
    if (!('departments' in value) || value['departments'] === undefined) return false;
    if (!('communes' in value) || value['communes'] === undefined) return false;
    if (!('postcodes' in value) || value['postcodes'] === undefined) return false;
    if (!('assets' in value) || value['assets'] === undefined) return false;
    if (!('assetHierarchy' in value) || value['assetHierarchy'] === undefined) return false;
    return true;
}

export function PartnerMaintenanceScopeOptionsResponseDtoFromJSON(json: any): PartnerMaintenanceScopeOptionsResponseDto {
    return PartnerMaintenanceScopeOptionsResponseDtoFromJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerMaintenanceScopeOptionsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'manufacturers': ((json['manufacturers'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'models': ((json['models'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'departments': ((json['departments'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'communes': ((json['communes'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'postcodes': ((json['postcodes'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'assets': ((json['assets'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoFromJSON)),
        'assetHierarchy': ((json['assetHierarchy'] as Array<any>).map(PartnerMaintenanceScopeHierarchyAssetDtoFromJSON)),
    };
}

export function PartnerMaintenanceScopeOptionsResponseDtoToJSON(json: any): PartnerMaintenanceScopeOptionsResponseDto {
    return PartnerMaintenanceScopeOptionsResponseDtoToJSONTyped(json, false);
}

export function PartnerMaintenanceScopeOptionsResponseDtoToJSONTyped(value?: PartnerMaintenanceScopeOptionsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'manufacturers': ((value['manufacturers'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'models': ((value['models'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'departments': ((value['departments'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'communes': ((value['communes'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'postcodes': ((value['postcodes'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'assets': ((value['assets'] as Array<any>).map(PartnerMaintenanceScopeOptionDtoToJSON)),
        'assetHierarchy': ((value['assetHierarchy'] as Array<any>).map(PartnerMaintenanceScopeHierarchyAssetDtoToJSON)),
    };
}

